import { gql } from '@apollo/client';

export const SPACE_FIELDS = gql`
  fragment SpaceFields on Space {
    id
    roomNumber
    roomName
    seatCount
    usf
    rank
    isAlternativeWorkpoint
    alternativeWorkpointSeats
    allowBlankSeats
    allowBlankUsf
    floorId
    floorplanPoint {
      x
      y
    }
    photos {
      id
      name
      description
      insertedAt
    }
    notes {
      id
      name
      text
      insertedAt
    }
    projectSpaceTypeId
    projectSpaceType {
      id
      spaceType {
        id
        spaceType
        name
        isCustom
      }
      clientFacingName
      category {
        id
        name
        icon
        defaultSpaceTypeCategory {
          id
          name
          category
        }
        parentId
        includeInTotalWorkSeats
      }
    }
    spaceType {
      id
      name
      spaceType
      spaceTypeCategory {
        id
        name
        category
      }
      icon
    }
    floor {
      id
    }
  }
`;
